export class Countdown {
    private items: Array<{ type: keyof ReturnType<Countdown['getTimes']>; value: HTMLElement; current: string }> = [];
    private end: Date;
    private interval: number | null = null;
    private selector: string;
    private readonly cartUpdatedHandler = () => {
        this.clearTimer();
        const fresh = document.querySelector<HTMLElement>(this.selector);
        if (fresh) this.element = fresh;
        this.init();
    };

    constructor(private element: HTMLElement) {
        this.selector = `[data-end="${element.getAttribute('data-end')}"]`;
        this.init();
        window.addEventListener('woocommerce_cart_updated', this.cartUpdatedHandler);
    }

    private init(): void {
        this.setValues();

        this.updateTimes();

        this.interval = setInterval(() => this.updateTimes(), 1000);
    }

    private updateTimes() {
        const times = this.getTimes();

        this.items.forEach((item) => {
            const newValue = times[item.type].toString().padStart(2, '0');

            if (item.current !== newValue) {
                item.current = newValue;
                item.value.innerHTML = `<span class="countdown-digit">${newValue[0]}</span><span class="countdown-digit">${newValue[1]}</span>`;
            }
        });
    }

    private getTimes() {
        const remaining = Math.max(0, this.end.getTime() - Date.now());

        return {
            days: Math.floor(remaining / (1000 * 60 * 60 * 24)),
            hours: Math.floor((remaining / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((remaining / (1000 * 60)) % 60),
            seconds: Math.floor((remaining / 1000) % 60)
        };
    }

    private setValues() {
        this.items = Array.from(this.element.querySelectorAll<HTMLElement>('.countdown-item')).reduce<typeof this.items>((items, item) => {
            const type = item.getAttribute('data-type') as keyof ReturnType<Countdown['getTimes']> | null;
            const value = item.querySelector<HTMLElement>('.countdown-item-value');

            if (type && value) {
                items.push({type, value, current: value.textContent?.trim() || ''});
            }

            return items;
        }, []);
        const endString = this.element.getAttribute('data-end');
        const endDateTime = endString ? new Date(Number(endString) * 1000) : null;

        if (!endDateTime || isNaN(endDateTime.getTime())) {
            throw new Error('Invalid or missing data-end attribute for Countdown animation.');
        }

        this.end = endDateTime;
    }

    destroy(): void {
        this.clearTimer();
        window.removeEventListener('woocommerce_cart_updated', this.cartUpdatedHandler);
    }

    private clearTimer(): void {
        clearInterval(this.interval);
        this.interval = null;
    }
}
